import { Component, OnInit } from '@angular/core';
import { FormsModule }   from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

@Component({
    selector: 'app-verifica',
    templateUrl: './verifica.component.html',
    styleUrls: ['./verifica.component.scss'],
    standalone: false
})

// @NgModule({
//   imports: [
//     BrowserModule,
//     FormsModule
//   ]
// })

export class VerificaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}